import React, { useState } from 'react';
import { FaShare } from 'react-icons/fa';
import { buyCourse } from '../../../services/operations/buyCourseApi';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationModal from '../../common/ConfirmationModal';
import { addToWishlist, removeFromWishlist } from '../../../redux/slices/wishlistSlice';

const CourseBuyingCard = ({ course, user, courseId, handlerShareButton }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isPresentInWishlist } = useSelector(state => state.wishlist);
    const [confirmationModal, setConfirmationModal] = useState(null);

    const modalData = {
        text1: "Access Restricted ❗️",
        text2: "To make a purchase and unlock our premium courses, please create an account or log in to your existing one. We're here to help you on your learning journey",
        btn1Text: "Login",
        btn2Text: "Signup",
        btn1Handler: () => navigate('/login'),
        btn2Handler: () => navigate('/signup'),
        closeModal: () => setConfirmationModal(null),
    };
    const handlerBuyCourse = () => {
        if (!user) {
            setConfirmationModal(modalData);
        } else {
            buyCourse([courseId], user, navigate, dispatch);
        }
    };

    const handleGoToCourse = () => {
        navigate(
            `/course/${course?.courseName.toLowerCase()}/${course?._id}/${course?.courseContent?.[0]?._id}/${course?.courseContent?.[0]?.subSection?.[0]?._id}`
        );
    };
    const handleWishlistButton = () => {
        if (!user) {
            setConfirmationModal(modalData);
        } else {
            if (isPresentInWishlist) {
                dispatch(removeFromWishlist(courseId));
            } else {
                dispatch(addToWishlist(course));
            }
        }
    };
    return (
        <div className='xl:w-[28rem] lg:w-[23rem] w-full lg:rounded-lg lg:bg-richblack-700 bg-richblack-800 p-4 lg:block sm:flex sm:justify-evenly'>
            <img
                className='object-cover lg:w-full sm:w-[60%] w-full rounded-xl xl:h-[17rem] lg:h-[12rem] h-[20rem]'
                loading='lazy'
                src={course?.thumbnail}
                alt={course?.courseName}
            />
            <div>
                <p className='text-3xl font-bold my-4 px-3'>
                    Rs. {parseInt(course?.price).toLocaleString()}
                </p>
                <div className='my-4 px-3'>
                    {course?.studentsEnrolled?.some((student) => student?._id === user?._id) ? (
                        <button
                            className='bg-yellow-50 w-full py-[8px] px-[20px] cursor-pointer font-semibold rounded-md transition-all duration-200 hover:scale-[.98] text-richblack-900'
                            type='button'
                            onClick={handleGoToCourse}
                        >
                            Go to Course
                        </button>
                    ) : (
                        <div className='flex flex-col'>
                            <button
                                className='bg-yellow-50 py-[8px] px-[20px] cursor-pointer font-semibold rounded-md transition-all duration-200 hover:scale-[.98] text-richblack-900'
                                type='button'
                                onClick={handlerBuyCourse}
                            >
                                Buy Course
                            </button>
                            {user && (
                                <button
                                    className='lg:bg-richblack-800 bg-richblack-700 py-[8px] px-[20px] cursor-pointer font-semibold rounded-md transition-all duration-200 hover:scale-[.98] mt-5 text-richblack-5'
                                    type='button'
                                    onClick={handleWishlistButton}
                                >
                                    {isPresentInWishlist ? "Remove from Wishlist" : "Add to Wishlist"}
                                </button>
                            )}
                        </div>
                    )}
                </div>
                <p className='text-center text-sm text-richblack-100 my-4'>
                    30-Day Money-Back Guarantee
                </p>
                <div className='flex justify-center'>
                    <button
                        type='button'
                        className='flex items-center gap-2 text-yellow-50 font-bold transition-all duration-200 hover:scale-[.98]'
                        onClick={handlerShareButton}
                    >
                        <FaShare /> Share
                    </button>
                </div>
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    );
};

export default CourseBuyingCard;